import { Navigate, Route, Routes } from 'react-router-dom';
import { BookmarkList } from './BookmarkList';

export const BookmarkRoutes = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="list" replace />} />
      <Route path="list" element={<BookmarkList />} />
    </Routes>
  );
};
